import {isResetPasswordPage, isSignUpPage} from '../utils/common'
;(function() {
  angular
    .module('app.directives', [])
    .directive('imgHolder', [
      function() {
        return {
          restrict: 'A',
          link: function(scope, ele, attrs) {
            return Holder.run({
              images: ele[0],
            })
          },
        }
      },
    ])
    .directive('customBackground', function() {
      const getClass = (path = '') => {
        if (isSignUpPage(path) || isResetPasswordPage(path)) {
          return 'body-special'
        }

        switch (path) {
          case '/':
          case '/404':
          case '/502':
          case '/500':
          case '/signin':
          case '/forgot':
          case '/admin/firm-management':
          case '/admin/job-creation':
          case '/admin/applied-jobs':
          case '/invite-friend':
          case '/profile':
          case '/user-profile':
          case '/admin/admin-listings':
          case '/admin/inactive-positions':
          case '/admin/lawyer-listing':
          case '/admin/referral-listing':
          case '/admin/email-listing':
          case '/admin/employers-listing':
          case '/admin/application-listing':
          case '/admin/matching-lawyers-listing':
          case '/opportunities':
          case '/connections':
          case '/home':
          case '/change-password':
          case '/admin/lawyer-profile':
          case '/admin/job-edit':
          case '/admin/job-clone':
          case '/for-employers':
          case '/about':
          case '/faqs':
          case '/terms-conditions':
          case '/privacy-policy':
          case '/invite-friends':
          case '/sitemap':
          case '/sitemap.xml':
          case '/new-lawyer-referral':
          case '/admin/matching-lawyers':
          case '/site-maintenance':
          case '/get-in-touch':
          case '/inhouse-jobs':
          case '/matches':
          case '/unsubscribe':
          case '/admin/firm-notes':
          case '/pause':
          case '/admin/email-history':
          case '/admin/email-history-view':
          case '/admin/edit-email':
          case '/admin/email-body':
            return 'body-special'
          case '/pages/lock-screen':
            return 'body-special body-lock'
          case '/tasks':
            return 'body-tasks'
          default:
            return ''
        }
      }

      return {
        restrict: 'A',
        controller: [
          '$scope',
          '$element',
          '$location',
          function($scope, $element, $location) {
            var addBg, path
            path = function() {
              return $location.path()
            }
            addBg = function(path) {
              $element.removeClass(
                'body-home body-special body-tasks body-lock'
              )
              $element.addClass(getClass(path))
            }
            addBg($location.path())
            return $scope.$watch(path, function(newVal, oldVal) {
              if (newVal === oldVal) {
                return
              }
              return addBg($location.path())
            })
          },
        ],
      }
    })
    .directive('uiColorSwitch', [
      function() {
        return {
          restrict: 'A',
          link: function(scope, ele, attrs) {
            return ele.find('.color-option').on('click', function(event) {
              var $this, hrefUrl, style
              $this = $(this)
              hrefUrl = void 0
              style = $this.data('style')
              if (style === 'loulou') {
                hrefUrl = 'styles/main.css'
                $('link[href^="styles/main"]').attr('href', hrefUrl)
              } else if (style) {
                style = '-' + style
                hrefUrl = 'styles/main' + style + '.css'
                $('link[href^="styles/main"]').attr('href', hrefUrl)
              } else {
                return false
              }
              return event.preventDefault()
            })
          },
        }
      },
    ])
    .directive('toggleMinNav', [
      '$rootScope',
      function($rootScope) {
        return {
          restrict: 'A',
          link: function(scope, ele, attrs) {
            var $content, $nav, $window, Timer, app, updateClass
            app = $('#app')
            $window = $(window)
            $nav = $('#nav-container')
            $content = $('#content')
            ele.on('click', function(e) {
              if (app.hasClass('nav-min')) {
                app.removeClass('nav-min')
              } else {
                app.addClass('nav-min')
                $rootScope.$broadcast('minNav:enabled')
              }
              return e.preventDefault()
            })
            Timer = void 0
            updateClass = function() {
              var width
              width = $window.width()
              if (width < 768) {
                return app.removeClass('nav-min')
              }
            }
            return $window.resize(function() {
              var t
              clearTimeout(t)
              return (t = setTimeout(updateClass, 300))
            })
          },
        }
      },
    ])
    .directive('collapseNav', [
      function() {
        return {
          restrict: 'A',
          link: function(scope, ele, attrs) {
            var $a, $aRest, $lists, $listsRest, app
            $lists = ele.find('ul').parent('li')
            $lists.append('<i class="fa fa-caret-right icon-has-ul"></i>')
            $a = $lists.children('a')
            $listsRest = ele.children('li').not($lists)
            $aRest = $listsRest.children('a')
            app = $('#app')
            $a.on('click', function(event) {
              var $parent, $this
              if (app.hasClass('nav-min')) {
                return false
              }
              $this = $(this)
              $parent = $this.parent('li')
              $lists
                .not($parent)
                .removeClass('open')
                .find('ul')
                .slideUp()
              $parent
                .toggleClass('open')
                .find('ul')
                .stop()
                .slideToggle()
              return event.preventDefault()
            })
            $aRest.on('click', function(event) {
              return $lists
                .removeClass('open')
                .find('ul')
                .slideUp()
            })
            return scope.$on('minNav:enabled', function(event) {
              return $lists
                .removeClass('open')
                .find('ul')
                .slideUp()
            })
          },
        }
      },
    ])
    .directive('highlightActive', [
      function() {
        return {
          restrict: 'A',
          controller: [
            '$scope',
            '$element',
            '$attrs',
            '$location',
            function($scope, $element, $attrs, $location) {
              var highlightActive, links, path
              links = $element.find('a')
              path = function() {
                return $location.path()
              }
              highlightActive = function(links, path) {
                path = '#' + path
                return angular.forEach(links, function(link) {
                  var $li, $link, href
                  $link = angular.element(link)
                  $li = $link.parent('li')
                  href = $link.attr('href')
                  if ($li.hasClass('active')) {
                    $li.removeClass('active')
                  }
                  if (path.indexOf(href) === 0) {
                    return $li.addClass('active')
                  }
                })
              }
              highlightActive(links, $location.path())
              return $scope.$watch(path, function(newVal, oldVal) {
                if (newVal === oldVal) {
                  return
                }
                return highlightActive(links, $location.path())
              })
            },
          ],
        }
      },
    ])
    .directive('toggleOffCanvas', [
      function() {
        return {
          restrict: 'A',
          link: function(scope, ele, attrs) {
            return ele.on('click', function() {
              return $('#app').toggleClass('on-canvas')
            })
          },
        }
      },
    ])
    .directive('slimScroll', [
      function() {
        return {
          restrict: 'A',
          link: function(scope, ele, attrs) {
            return ele.slimScroll({
              height: attrs.scrollHeight || '100%',
            })
          },
        }
      },
    ])
    .directive('goBack', [
      function() {
        return {
          restrict: 'A',
          controller: [
            '$scope',
            '$element',
            '$window',
            function($scope, $element, $window) {
              return $element.on('click', function() {
                return $window.history.back()
              })
            },
          ],
        }
      },
    ])
    .directive('readMore', function($sce) {
      return {
        restrict: 'AE',
        scope: {
          hmtext: '@',
          hmlimit: '@',
          hmfulltext: '@',
          hmMoreText: '@',
          hmLessText: '@',
          hmMoreClass: '@',
          hmLessClass: '@',
        },
        template: `
          <span ng-if="hmtext.length > hmlimit">
            <span ng-hide="hmfulltext" ng-bind-html="hmtext | limitTo:hmlimit"></span>
            <span ng-hide="hmfulltext">
              ... &nbsp;&nbsp;
              <a class="more-class" href="" ng-click="toggleValue()">{{ hmMoreText }}</a>
            </span>
            <p ng-show="hmfulltext" ng-bind-html="hmtext"></p>
            <span ng-show="hmfulltext">
              <br>
              <a class="more-class" href="" ng-click="toggleValue()">{{ hmLessText }}</a>
            </span>
          </span>

          <span ng-if="hmtext.length <= hmlimit" ng-bind-html="hmtext"></span>

          <style type="text/css">
            .more-class {
              color: #4c9bda;
            }
          </style>
      `,
        transclude: true,
        controller: function($scope) {
          $scope.toggleValue = function() {
            $scope.hmfulltext = !$scope.hmfulltext
          }
        },
      }
    })
    .directive('onlyAlphabets', function() {
      var isALetter,
        allowedChars = [' ', '&', "'", '’', ',', '-', '_']
      isALetter = function(charVal) {
        return charVal.toUpperCase() !== charVal.toLowerCase() ||
          allowedChars.includes(charVal)
          ? true
          : false
      }
      return {
        restrict: 'A',
        require: '?ngModel',
        link: function(scope, element, attrs, ngModel) {
          if (!ngModel) {
            return
          }
          ngModel.$parsers.unshift(function(inputValue) {
            var alphabets
            alphabets = inputValue
              .split('')
              .filter(function(s) {
                return isALetter(s)
              })
              .join('')
            ngModel.$viewValue = alphabets
            ngModel.$render()
            return alphabets
          })
        },
      }
    })
    .directive('isAlphabet', function() {
      var isALetter,
        allowedChars = [' ', '-', "'"]
      isALetter = function(charVal) {
        return charVal.toUpperCase() !== charVal.toLowerCase() ||
          allowedChars.includes(charVal)
          ? true
          : false
      }
      return {
        restrict: 'A',
        require: '?ngModel',
        link: function(scope, element, attrs, ngModel) {
          if (!ngModel) {
            return
          }
          ngModel.$parsers.unshift(function(inputValue) {
            var alphabets
            alphabets = inputValue
              .split('')
              .filter(function(s) {
                return isALetter(s)
              })
              .join('')
            ngModel.$viewValue = alphabets
            ngModel.$render()
            return alphabets
          })
        },
      }
    })
    .directive('onlyNumbers', function() {
      var isALetter
      isALetter = function(charVal) {
        if (
          charVal.toUpperCase() !== charVal.toLowerCase() ||
          charVal === ' ' ||
          charVal === ',' ||
          charVal === '.' ||
          charVal === 'm'
        ) {
          return false
        } else {
          return true
        }
      }
      return {
        restrict: 'A',
        require: '?ngModel',
        link: function(scope, element, attrs, ngModel) {
          if (!ngModel) {
            return
          }
          ngModel.$parsers.unshift(function(inputValue) {
            var alphabets
            alphabets = inputValue
              .split('')
              .filter(function(s) {
                return isALetter(s)
              })
              .join('')
            ngModel.$viewValue = alphabets
            ngModel.$render()
            return alphabets
          })
        },
      }
    })
    .directive('alphabetsNumbers', function() {
      var isALetter
      isALetter = function(charVal) {
        if (
          charVal.toUpperCase() !== charVal.toLowerCase() ||
          charVal === ' ' ||
          charVal === '_' ||
          charVal === '-' ||
          charVal === '.' ||
          ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].indexOf(charVal) >=
            0
        ) {
          return true
        } else {
          return false
        }
      }
      return {
        restrict: 'A',
        require: '?ngModel',
        link: function(scope, element, attrs, ngModel) {
          if (!ngModel) {
            return
          }
          ngModel.$parsers.unshift(function(inputValue) {
            var alphabets
            alphabets = inputValue
              .split('')
              .filter(function(s) {
                return isALetter(s)
              })
              .join('')
            ngModel.$viewValue = alphabets
            ngModel.$render()
            return alphabets
          })
        },
      }
    })
    .directive('limitTo', [
      function() {
        return {
          restrict: 'A',
          link: function(scope, elem, attrs) {
            var limit
            limit = parseInt(attrs.limitTo)
            angular.element(elem).on('keypress', function(e) {
              if (this.value.length === limit) {
                e.preventDefault()
              }
            })
          },
        }
      },
    ])
    .directive('addfields', function($compile) {
      return function(scope, element, attrs) {
        element.bind('click', function() {
          scope.educationFields = false
          angular
            .element(document.getElementById('space-for-fields'))
            .append($compile('')(scope))
        })
      }
    })
    .directive('alert', function() {
      return function(scope, element, attrs) {
        element.bind('click', function() {
          // alert('This is alert #' + attrs.alert)
        })
      }
    })
    .directive('ngRightClick', function($parse) {
      return function(scope, element, attrs) {
        var fn
        fn = $parse(attrs.ngRightClick)
        element.bind('contextmenu', function(event) {
          scope.$apply(function() {
            event.preventDefault()
            fn(scope, {
              $event: event,
            })
          })
        })
      }
    })
}.call(this))



// WEBPACK FOOTER //
// ./scripts/shared/directives/directives.js